module.exports = "https://www.gc-pro.gnp.com.mx/7e986e675c330dcb5fb29055fd32eb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/delete-pass.png
// module id = 964
// module chunks = 0